/* ================================================
  Trapfocus (a11y)
================================================== */

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) { return; }

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') { return; }

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) {
    elementToFocus.focus();
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/* ================================================
  Tab outline
================================================== */

document.addEventListener('keydown', (event) => {
  if (event.keyCode !== 9 || document.body.classList.contains('tab-outline')) { return; }
  document.body.classList.add('tab-outline');
});

/* ================================================
  No JS
================================================== */

document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

/* ================================================
  On key up escape
================================================== */

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

/* ================================================
  Viewport height
================================================== */

const vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
document.documentElement.style.setProperty('--static-vh', `${vh}px`);

window.addEventListener('resize', () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/* ================================================
  Detect chrome iOs
================================================== */

if (navigator.userAgent.match('CriOS')) {
  document.body.classList.add('chrome-ios');
}

/* ================================================
  Helper functions
================================================== */

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

let lastScrollPosition = null;

function scrollLock() {
  const siteContent = document.querySelector('[data-site-content]');

  lastScrollPosition = window.scrollY;
  document.documentElement.classList.add('scroll-lock');
  document.body.classList.add('scroll-lock');
  siteContent.style.marginTop = `-${lastScrollPosition}px`;
}

function removeScrollLock() {
  const siteContent = document.querySelector('[data-site-content]');

  document.documentElement.classList.remove('scroll-lock');
  document.body.classList.remove('scroll-lock');
  siteContent.style.marginTop = '';

  if (lastScrollPosition != null) {
    window.scrollTo(0, lastScrollPosition);
  }
}

/* ================================================
  Open external links in new tab
================================================== */

const links = document.querySelectorAll('a');

if (links.length) {
  links.forEach((link) => {
    if(link.hostname === window.location.hostname || link.getAttribute('target') === '_blank') { return; }
    link.setAttribute('target', '_blank');
  });
}

/* ================================================
  Responsive videos
================================================== */

const iframes = document.querySelectorAll('iframe');

if (iframes.length) {
  iframes.forEach((iframe) => {
    if (iframe.closest('.responsive-video')) { return; }

    const iframeSrc = iframe.getAttribute('src');

    if (iframeSrc.indexOf('youtube') === -1 && iframeSrc.indexOf('vimeo') === -1) { return; }

    const responsiveVideoWrapper = document.createElement('div');

    responsiveVideoWrapper.classList.add('responsive-video');
    iframe.parentNode.insertBefore(responsiveVideoWrapper, iframe);
    responsiveVideoWrapper.appendChild(iframe);
  });
}

/* ================================================
  Animate on scroll
================================================== */

if (document.body.hasAttribute('data-animations-enabled')) {
  document.addEventListener('DOMContentLoaded', () => {
    window.AOS.init({
      disable: 'mobile',
      once: true,
      offset: 200
    });
  });

  window.addEventListener('load', () => {
    window.AOS.refresh();
  });

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      window.AOS.refreshHard();
    });
  }
}

/* ================================================
  Seal Subscriptions - reveal widget on Add to Cart click
================================================== */

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[name="add"]');
  if (!btn) return;

  const productForm = btn.closest('product-form');
  if (!productForm) return;

  const subsWidget = productForm.querySelector('.sealsubs-target-element');
  if (!subsWidget) return;

  if (!subsWidget.classList.contains('sls-revealed')) {
    e.preventDefault();
    e.stopImmediatePropagation();
    subsWidget.classList.add('sls-revealed');

    const hint = productForm.querySelector('.sls-atc-hint');
    if (hint) hint.style.display = 'none';
  }
}, true); // capture phase — fires before carousel handlers